module.exports = __webpack_public_path__ + "static/media/1017093.f20b75ac.png";